import { render } from "./ope_com_editnew.vue?vue&type=template&id=5a2d459e&scoped=true"
import script from "./ope_com_editnew.vue?vue&type=script&lang=js"
export * from "./ope_com_editnew.vue?vue&type=script&lang=js"

import "./css/contact.scss?vue&type=style&index=0&id=5a2d459e&lang=scss&scoped=true"

import exportComponent from "/var/lib/jenkins/workspace/div2-univRenewal-trunk-production/web/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5a2d459e"]])

export default __exports__